function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * AAAA IDP Payment page
 * 
 */
import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import ErrorApp from '../../components/error-app/ErrorApp';
import Loading from '../../components/loading/Loading';
import Progress from '../../components/progress/Progress';
import { Fn } from '../../functions/Functions';
import { API, gatewayForDomain, OPTIONS } from '../../data/Data';
import { getMetaCookies } from '../../utils/metaPixel';
import './Completed.scss';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const LOADING_TEXT = 'Your transaction is processing. Do not use the browser back button, refresh, or leave this page until you see the confirmation notice';
export class Completed extends Component {
  constructor(props) {
    super(props);
    /**
     * Format postage description for display
     * @param {string|null} rawPostage - Raw postage value from URL
     * @returns {string|null} Formatted postage description
     */
    _defineProperty(this, "formatPostageDescription", rawPostage => {
      if (!rawPostage) {
        return null;
      }
      const decodedPostage = decodeURIComponent(rawPostage);

      // Check for in-store pickup
      if (decodedPostage === 'In-store+pickup') {
        return 'In-store pickup';
      }

      // If it already contains a proper description text
      return decodedPostage;
    });
    /**
    * Send transaction details to API
    */
    _defineProperty(this, "sendToApi", () => {
      let {
        data,
        appId,
        submission_token,
        retries
      } = this.state;
      if (!appId || !submission_token) {
        return;
      }
      const metaCookies = getMetaCookies();
      data = {
        amount: data.paymentAmount,
        id: appId,
        hash_check: data.hashCheck,
        payment_date: data.paymentDate ?? null,
        payment_number: data.paymentNumber ?? null,
        receipt_number: data.receiptNumber,
        response_code: data.responseCode,
        response_body: data.responseDescription,
        reference: data.paymentReference,
        status: data.success === null ? 'pending' : data.success ? 'success' : 'fail',
        transaction_timestamp: data.createdDateTime,
        submission_token,
        summary_code: data.summaryCode,
        token: data.cardToken,
        fbp: metaCookies.fbp,
        fbc: metaCookies.fbc
      };
      console.warn('data POST to API', data);
      this.setState({
        retries: retries + 1
      }, () => {
        console.warn('retries', this.state.retries);
      });
      const options = {
        ...OPTIONS,
        body: JSON.stringify(data)
      };
      const url = `${API}/${appId}/payment/transaction`;

      // send to API
      fetch(url, options).then(response => {
        console.warn('response.status', response.status);
        if (response.status >= 400) {
          this.notOk(response);
        } else {
          return response.json();
        }
      }).then(result => {
        if (result) {
          this.success(result);
        }
      }).catch(err => this.error(err));
    });
    /**
     * Handle >= 400 API response
     */
    _defineProperty(this, "notOk", response => {
      response.json().then(result => this.fail(result, response.status));
      return true;
    });
    /**
     * failed >=400 API response.json()
     */
    _defineProperty(this, "fail", (result, status) => {
      const {
        bugsnagClient,
        jest
      } = this.props;
      const {
        appId,
        gateway: {
          name
        }
      } = this.state;
      let {
        errors,
        message
      } = result;
      console.warn('Transaction failed application Id: ', appId);
      console.warn('API message: ', message);
      if (name === 'fatzebra') {
        if (errors) {
          for (let param in errors) {
            console.warn(errors[param]);
          }
        }
      }
      const err = new Error(`APi result failed ${status}; ${message ? message : ''}; ${errors ? JSON.stringify(errors) : ''}`);
      if (jest) {
        return null;
      }

      // Log to Bugsnag, then redirect
      bugsnagClient.notify(err, null, () => {
        this.redirect('true', 'fail', message ? message : '');
      });
    });
    /**
     * success posting to API, 200 response
     */
    _defineProperty(this, "success", result => {
      const {
        response_body,
        status
      } = result.data ? result.data : {
        response_body: '',
        status: ''
      };
      this.redirect('true', status ? status : '', response_body ? response_body : '');
    });
    /**
    * Error
    */
    _defineProperty(this, "error", async (err, message = '') => {
      const {
        bugsnagClient,
        jest
      } = this.props;
      let {
        appId,
        retries
      } = this.state;
      if (jest) return null;
      console.warn(err);
      console.warn('window.location.search', window.location.search);
      console.warn('retries', retries);
      if (!message) {
        err.message = `${err.message}; Application id: ${appId ? appId : 'MISSING'}`;
      } else {
        console.warn(message);
      }
      if (retries >= 5) {
        // Log to Bugsnag, then redirect
        bugsnagClient.notify(err, null, () => {
          this.redirect('false', 'sent', '');
        });
      } else {
        bugsnagClient.notify(err, null, () => {
          this.retrySendToApi();
        });
      }
    });
    /**
     * Retry sending data to the API with back off
     */
    _defineProperty(this, "retrySendToApi", () => {
      this.timeout = setTimeout(() => this.sendToApi(), this.state.retryDelay[this.state.retries]);
    });
    /**
    * redirect with search params
    * @param {*} result
    */
    _defineProperty(this, "redirect", (apiSuccess, status, responseDescription) => {
      const {
        jest
      } = this.props;
      const {
        appId,
        data,
        postageDescription,
        submission_token
      } = this.state;
      const {
        createdDateTime,
        paymentAmount,
        receiptNumber
      } = data;
      const {
        origin
      } = window.location;
      const search = new URLSearchParams();
      search.set('createdDateTime', createdDateTime ? createdDateTime : '');
      search.set('id', appId ? appId : '');
      search.set('submission_token', submission_token ? submission_token : '');
      search.set('apiSuccess', apiSuccess);
      search.set('status', status);
      search.set('paymentAmount', paymentAmount ? paymentAmount : '');
      search.set('postageDescription', postageDescription ? postageDescription : '');
      search.set('responseDescription', responseDescription);
      // Include receiptNumber for Meta Pixel deduplication with server-side CAPI
      search.set('receiptNumber', receiptNumber ? receiptNumber : '');
      if (jest) return null;
      // Replace href so history of the completed page is removed
      window.location.href = `${origin}/confirmation?${search.toString()}`;
    });
    const {
      jest: _jest,
      location
    } = props;
    const {
      search: _search
    } = props.location;
    const params = new URLSearchParams(_search);
    const _appId = params.get('appId');
    const id = params.get('id');
    const _submission_token = params.get('submission_token');
    const _rawPostage = params.get('postage');
    const postageDescriptionParam = params.get('postageDescription');

    // For NAB Transact orders, use postageDescription parameter; otherwise use formatted postage
    const _postageDescription = postageDescriptionParam || this.formatPostageDescription(_rawPostage);
    const _responseDescription = params.get('responseDescription');
    const _status = params.get('status');
    const _apiSuccess = params.get('apiSuccess');
    const {
      host
    } = window.location;
    const gateway = gatewayForDomain(host, null, null, null, null);
    const _data = Fn.extractGatewayVars(gateway.name, location, _jest);
    this.state = {
      apiSuccess: _apiSuccess,
      appId: _appId,
      id,
      data: _data,
      gateway,
      postageDescription: _postageDescription,
      responseDescription: _responseDescription,
      spinner: true,
      status: _status,
      submission_token: _submission_token,
      retries: 0,
      retryDelay: [0, 1000, 2000, 3000, 4000, 8000]
    };
    this.timeout = null;
  }
  componentDidMount() {
    setTimeout(() => this.sendToApi(), 1000);
  }
  componentWillUnmount() {
    clearTimeout(this.timeout);
  }
  render() {
    const {
      bugsnagClient
    } = this.props;
    const {
      appId,
      submission_token
    } = this.state;
    if (!appId || !submission_token) {
      return /*#__PURE__*/_jsx(ErrorApp, {
        bugsnagClient: bugsnagClient
      });
    }
    return /*#__PURE__*/_jsxs(Fragment, {
      children: [/*#__PURE__*/_jsx(Progress, {}), /*#__PURE__*/_jsx("section", {
        className: "form-container",
        children: /*#__PURE__*/_jsx("div", {
          className: "Completed",
          children: /*#__PURE__*/_jsx(Loading, {
            text: LOADING_TEXT
          })
        })
      })]
    });
  }
}
_defineProperty(Completed, "defaultProps", {
  jest: false,
  location: {
    search: ''
  }
});
export default withRouter(Completed);